import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OpenRoutingModule } from './open-routing.module';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorMessageComponent } from "../shared/components/error-message/error-message.component";
import { PuzzleCaptchaComponent } from "./puzzle-captcha/puzzle-captcha.component";
import { PaymentInitializeComponent } from './payment/payment-initialize/payment-initialize.component';
import { PaymentSuccessComponent } from './payment/payment-success/payment-success.component';
import { PaymentFailureComponent } from './payment/payment-failure/payment-failure.component';
import { VerificationLandingComponent } from './verification/verification-landing/verification-landing.component';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { VerificationDetailsComponent } from './verification/verification-details/verification-details.component';
import { SharedModule } from '../shared/shared.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


@NgModule({
  declarations: [LoginComponent, HomeComponent, ForgotPasswordComponent, PuzzleCaptchaComponent, PaymentInitializeComponent, PaymentSuccessComponent, PaymentFailureComponent, VerificationLandingComponent, VerificationDetailsComponent, ResetPasswordComponent],
  imports: [
    CommonModule,
    OpenRoutingModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgSelectModule

]
})
export class OpenModule { }
